import { Typography } from '@material-ui/core';
import React from 'react';
import { LinearProgressWithLabel } from '../functions';

const OIModalLoading = () => {
  return (
    <div style={{ paddingTop: '150px' }}>
      <LinearProgressWithLabel />

      <Typography
        variant="body2"
        color="text.secondary"
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        {' '}
        Please standby. Retrieving the data...{' '}
      </Typography>
    </div>
  );
};
export default OIModalLoading;



// WEBPACK FOOTER //
// ./src/components/Modals/OI Modal/components/OIModalLoading.jsx